import { __assign, __read, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { CollapsePanel } from "./CollapsePanel";
import { CollapseContext } from "./CollapseContext";
import { useDefault } from "../_util/use-default";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var Collapse = forwardRefWithStatics(function Collapse(_a, ref) {
    var accordion = _a.accordion, activeIds = _a.activeIds, _b = _a.defaultActiveIds, defaultActiveIds = _b === void 0 ? [] : _b, onActive = _a.onActive, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? "left" : _c, destroyInactivePanel = _a.destroyInactivePanel, children = _a.children, className = _a.className, props = __rest(_a, ["accordion", "activeIds", "defaultActiveIds", "onActive", "icon", "iconPosition", "destroyInactivePanel", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    var _d = __read(useDefault(activeIds, defaultActiveIds, onActive), 2), value = _d[0], onChange = _d[1];
    var handleChange = function (activeIds, _a) {
        var event = _a.event, activeId = _a.activeId, active = _a.active;
        if (!accordion) {
            onChange(activeIds, { event: event, activeId: activeId, active: active });
        }
        else {
            onChange(active ? [activeId] : [], { event: event, activeId: activeId, active: active });
        }
    };
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-accordion-group", className) }, props),
        React.createElement(CollapseContext.Provider, { value: {
                activeIds: value,
                onActive: handleChange,
                icon: icon,
                iconPosition: iconPosition,
                destroyInactivePanel: destroyInactivePanel,
            } }, children)));
}, {
    Panel: CollapsePanel,
});
Collapse.displayName = "Collapse";
//# sourceMappingURL=Collapse.js.map